import {BaseService} from "./base.service";

class InvoicesService extends BaseService {

    constructor() {
        //super('api/invoices-for-supplier')
        super('api/invoices')
    }

}

export const invoicesService = new InvoicesService();
